import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useContent } from "../context/ContentContext";
import ThemeToggle from "./ThemeToggle";

const Header = () => {
  const { NAV_LINKS } = useContent();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`dark-block fixed top-0 left-0 right-0 z-50 transition-[background-color,backdrop-filter,padding] duration-500 ${
        scrolled ? "backdrop-blur-md bg-canvas/70 py-1.5" : "backdrop-blur-sm bg-canvas/25 py-2.5"
      }`}
    >
      <div className="mx-auto px-6 md:px-10 flex items-center justify-between">
        <Link to="/" className="group flex items-center">
          <img
            src="/brand/samurai-logo.png"
            alt="SAMURAI"
            className="h-6 md:h-7 w-auto object-contain transition-opacity duration-300 group-hover:opacity-80"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {NAV_LINKS.map((n) => {
            const active = location.pathname === n.path;
            return (
              <Link
                key={n.path}
                to={n.path}
                className="relative text-ink/80 hover:text-ink text-[11px] uppercase tracking-[0.28em] transition-colors"
              >
                {n.label}
                <span
                  className={`absolute -bottom-1 left-0 h-px bg-ink transition-all duration-500 ${
                    active ? "w-full" : "w-0"
                  }`}
                />
              </Link>
            );
          })}
          <ThemeToggle />
        </nav>

        <div className="md:hidden flex items-center gap-3">
          <ThemeToggle compact />
          <button
            onClick={() => setOpen((o) => !o)}
            className="flex flex-col gap-1.5"
            aria-label="menu"
          >
            <span className={`h-px w-6 bg-ink transition-transform ${open ? "translate-y-[7px] rotate-45" : ""}`} />
            <span className={`h-px w-6 bg-ink transition-opacity ${open ? "opacity-0" : ""}`} />
            <span className={`h-px w-6 bg-ink transition-transform ${open ? "-translate-y-[5px] -rotate-45" : ""}`} />
          </button>
        </div>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-[max-height] duration-500 bg-canvas/95 backdrop-blur ${
          open ? "max-h-96" : "max-h-0"
        }`}
      >
        <div className="px-8 py-8 flex flex-col gap-5">
          {NAV_LINKS.map((n) => (
            <Link
              key={n.path}
              to={n.path}
              className="text-ink text-2xl font-heading font-black tracking-tight"
            >
              {n.label}
            </Link>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;
